import LogEvent from 'automation-ui-log-events/records/LogEvent/LogEvent';
import SimulatedActionExecutionEventV2, { HIGHLIGHT_CLASS_NAME } from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/SimulatedActionExecutionEventV2';
import { useEffect, useRef, useState } from 'react';
import { Map as ImmutableMap } from 'immutable';
import { setScrollToActionCardState } from 'automation-ui-canvas/utils/routingUtils';
import { useHistory } from 'react-router-dom';
import { WorkflowEndedPreview } from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/WorkflowEndedPreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SimulationActionsSection = ({
  flow,
  historyEvents = [],
  recordId,
  viewData
}) => {
  const history = useHistory();
  const {
    activeActionId,
    setActiveActionId
  } = viewData;
  const sectionRefById = useRef(ImmutableMap());
  const [openSectionsById, setOpenSectionsById] = useState(ImmutableMap({}));
  const getEventKey = event => {
    var _event$action$actionI, _event$action;
    return `${(_event$action$actionI = (_event$action = event.action) === null || _event$action === void 0 ? void 0 : _event$action.actionId) !== null && _event$action$actionI !== void 0 ? _event$action$actionI : 'enrollment'}`;
  };
  const deferredEvents = historyEvents === null || historyEvents === void 0 ? void 0 : historyEvents.filter(event => event.executionState === 'DEFERRED' || event.executionState === 'ASYNC').reduce((acc, event) => {
    acc.add(getEventKey(event));
    return acc;
  }, new Set());

  /* Scroll sidepanel to when action is clicked on canvas */
  useEffect(() => {
    if (activeActionId) {
      setOpenSectionsById(prev => prev.set(activeActionId, true));
      const sectionRef = sectionRefById.current.get(activeActionId);

      // Resets the highlight animation
      sectionRef.classList.remove(HIGHLIGHT_CLASS_NAME);

      /* Slight delay to allow accordion to open */
      setTimeout(() => {
        sectionRef.classList.add(HIGHLIGHT_CLASS_NAME);
        sectionRef === null || sectionRef === void 0 || sectionRef.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 250);
      setActiveActionId(undefined);
    }
  }, [activeActionId, setActiveActionId]);

  // Filter out success events that have a corresponding deferred event
  const eventsToRender = historyEvents === null || historyEvents === void 0 ? void 0 : historyEvents.filter(event => !(deferredEvents.has(getEventKey(event)) && event.executionState === 'SUCCESS'));
  const renderedEvents = eventsToRender.map(event => {
    var _event$action3, _event$action6;
    return /*#__PURE__*/_jsx(SimulatedActionExecutionEventV2, {
      ref: ref => {
        if (ref) {
          var _event$action$actionI2, _event$action2;
          sectionRefById.current = sectionRefById.current.set((_event$action$actionI2 = (_event$action2 = event.action) === null || _event$action2 === void 0 ? void 0 : _event$action2.actionId) !== null && _event$action$actionI2 !== void 0 ? _event$action$actionI2 : 'enrollment', ref);
        }
      },
      event: new LogEvent(event),
      flowObjectTypeId: flow.objectTypeId,
      flow: flow,
      recordId: recordId,
      branchOverrideValue: viewData.branchOverrides.get((_event$action3 = event.action) === null || _event$action3 === void 0 ? void 0 : _event$action3.actionId),
      setBranchOverrideValue: index => {
        var _event$action4;
        const actionId = (_event$action4 = event.action) === null || _event$action4 === void 0 ? void 0 : _event$action4.actionId;
        if (actionId) {
          var _event$action5;
          viewData.setBranchOverrides(viewData.branchOverrides.set((_event$action5 = event.action) === null || _event$action5 === void 0 ? void 0 : _event$action5.actionId, index));
        }
      },
      open: openSectionsById.get((_event$action6 = event.action) === null || _event$action6 === void 0 ? void 0 : _event$action6.actionId),
      onOpenChange: ({
        target: {
          value
        }
      }) => {
        var _event$action7;
        if ((_event$action7 = event.action) !== null && _event$action7 !== void 0 && _event$action7.actionId) {
          setOpenSectionsById(openSectionsById.set(event.action.actionId, value));
          if (value) {
            setScrollToActionCardState(event.action.actionId, history);
          }
        }
      },
      viewData: viewData
    }, getEventKey(event));
  });
  let prevActionId;
  let prevActionTimestamp;
  if (eventsToRender.length) {
    var _eventsToRender$actio;
    prevActionId = (_eventsToRender$actio = eventsToRender[eventsToRender.length - 1].action) === null || _eventsToRender$actio === void 0 ? void 0 : _eventsToRender$actio.actionId;
    prevActionTimestamp = eventsToRender[eventsToRender.length - 1].timestamp;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderedEvents, !viewData.executionShouldHalt && prevActionId && /*#__PURE__*/_jsx(WorkflowEndedPreview, {
      flow: flow,
      prevActionId: prevActionId,
      timestamp: prevActionTimestamp
    })]
  });
};
export default SimulationActionsSection;